import store from 'store/index';

export const types = {
    UPDATE_HEADER_WIDTH: 'UPDATE_HEADER_WIDTH',
    UPDATE_HEADER_POSITION: 'UPDATE_HEADER_POSITION',
    SET_INITIAL_HEADER_WIDTH: 'SET_INITIAL_HEADER_WIDTH',
    SET_INITIAL_HEADER_POSITION: 'SET_INITIAL_HEADER_POSITION'
};

// Initial State
const state = {
    theHeaderWidth: 0,
    theHeaderPosition: '',
    initialHeaderWidth: 0,
    initialHeaderPosition: ''
};

// Getters
const getters = {
    theCurrentHeaderWidth: state => state.theHeaderWidth,
    theCurrentHeaderPosition: state => state.theHeaderPosition,
    theInitialHeaderWidth: state => state.initialHeaderWidth,
    theInitialHeaderPosition: state => state.initialHeaderPosition
};

// Actions
const actions = {
    //value (width) passed in from the resize function
    updateHeaderWidth: ({ commit }, width) => commit(types.UPDATE_HEADER_WIDTH, width),
    updateHeaderPosition: ({ commit }, width) => commit(types.UPDATE_HEADER_POSITION, width),
    setInitialHeaderWidth: ({ commit }, width) => commit(types.SET_INITIAL_HEADER_WIDTH, width),
    setInitialHeaderPosition: ({ commit }, position) => commit(types.SET_INITIAL_HEADER_POSITION, position)
};


// Mutations
const mutations = {
    [types.SET_INITIAL_HEADER_WIDTH](state, {initialWidthValue}) {

        state.initialHeaderWidth = initialWidthValue;

    },
    [types.UPDATE_HEADER_WIDTH](state, {windowWidth}) {

        if(store.getters["menu/isMenuCollapsed"] === true) {
            state.theHeaderWidth = 98 + '%';
        }
        else if(windowWidth >= 1600 && state.initialHeaderPosition === 'fixed') {
            state.theHeaderWidth = 84 + '%';
        }
        else if(windowWidth <= 1024) {
            state.theHeaderWidth = 100 + '%';
        }
        else {
            state.theHeaderWidth = state.initialHeaderWidth + '%';
        }

    },
    [types.SET_INITIAL_HEADER_POSITION](state, {initialPositionValue}) {

        state.initialHeaderPosition = initialPositionValue;

    },
    [types.UPDATE_HEADER_POSITION](state, {windowWidth}) {

        state.theHeaderPosition = windowWidth <= 1024 ? 'relative' : state.initialHeaderPosition;

    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};


// WEBPACK FOOTER //
// ./src/store/modules/headerWidth.js